// Firebase configuration from environment variables
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
}

// Platform configuration
export const platformConfig = {
  environment: import.meta.env.MODE || 'production',
  name: 'Kiniela.mx',
  version: '1.0.0',
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL || 'soporte@kiniela.mx',
  maxDepositAmount: 10000,
  minDepositAmount: 50,
  minWithdrawalAmount: 100,
  commission: {
    percentage: 10,
    distribution: {
      platform: 5,
      firstPlace: 60,
      secondPlace: 25,
      thirdPlace: 15
    }
  }
}
